import { apiServer } from "../config";

export type FooterStat = {
  id: string;
  value: string;
  labelKey: string;
};

export type FooterAppStoreLink = {
  id: string;
  platform: string;
  url: string;
  image: string;
  ariaLabelKey: string;
};

export type FooterCheckOutMoreLink = {
  id: string;
  url: string;
  labelKey: string;
};

export type FooterSocialMediaLink = {
  id: string;
  url: string;
  icon: string;
  ariaLabelKey: string;
};

export type FooterSettings = {
  stats: FooterStat[];
  appStoreLinks: FooterAppStoreLink[];
  checkOutMoreLinks: FooterCheckOutMoreLink[];
  socialMediaLinks: FooterSocialMediaLink[];
  email: string;
};

export type FooterSettingsResponse = {
  status: string;
  message: string;
  data: [];
  desktop_footer_settings: FooterSettings;
};

export async function loadFooterSettings(): Promise<FooterSettings> {
  const response = await fetch(`${apiServer}/appsettings/footer`, {
    method: "GET",
  });
  const data: FooterSettingsResponse = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  } else {
    return data.desktop_footer_settings;
  }
}
